import styled from "styled-components";

const DarkPageWrap = styled.section`
  padding: 6rem var(--padding);
  background-color: var(--black);
`;

export default DarkPageWrap;
